import { render, staticRenderFns } from "./wxDefault.vue?vue&type=template&id=96ea2d62"
import script from "./wxDefault.vue?vue&type=script&lang=js"
export * from "./wxDefault.vue?vue&type=script&lang=js"
import style0 from "./wxDefault.vue?vue&type=style&index=0&id=96ea2d62&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports